import React, { useEffect, useState } from 'react';
import './Header.css';
import gripImage from '../../images/logo-grip.png';
import digiredoLogo from '../../images/DigiRedo-zwart-op-wit-z-strapline.png';
import User from '../../types/User';
import { THEME_COLOR } from '../../colors';

interface HeaderProps {
  onLogout: () => void;
  isLoggedIn: boolean;
  user: User | null;
}

const Header: React.FC<HeaderProps> = ({ onLogout, isLoggedIn, user }) => {
  return (
    <>
      <div className="header" style={{ backgroundColor: THEME_COLOR }}>
        <a href="/">
          <img style={{ padding: '10px', height: '50px', width: 'auto' }} src={digiredoLogo} alt="digiredoLogo" />
        </a>
        <div className="right">
          <a href="/">
            <img style={{ padding: '10px', height: '50px', width: 'auto' }} src={gripImage} alt="GripLogo" />
          </a>
        </div>
      </div>

      {isLoggedIn && user && (
        <div className="username-container">
          {user.name}
        </div>
      )}
    </>
  );
};

export default Header;